import React from 'react';
import { NavLink } from 'react-router-dom';
import type { NavItem } from './layoutNav';

type NavMenuLinksProps = {
  items: NavItem[];
  linkClassName?: string;
  onNavigate?: () => void;
  getItemClassName?: (item: NavItem, isActive: boolean) => string;
  /** Collapsed sidebar: icons only with native tooltips. */
  iconOnly?: boolean;
};

export default function NavMenuLinks({
  items,
  linkClassName = 'nav-link',
  onNavigate,
  getItemClassName,
  iconOnly = false,
}: NavMenuLinksProps) {
  return (
    <>
      {items.map((item) => (
        <NavLink
          key={item.id}
          to={item.href}
          end={item.end}
          title={iconOnly ? item.label : undefined}
          aria-label={iconOnly ? item.label : undefined}
          className={({ isActive }) => {
            const base = `${linkClassName}${item.highlight ? ' nav-link-cta' : ''}${isActive ? ' active' : ''}${iconOnly ? ' nav-link--icon-only' : ''}`;
            return getItemClassName ? getItemClassName(item, isActive) : base;
          }}
          onClick={() => onNavigate?.()}
        >
          <item.Icon className="nav-icon" />
          {iconOnly ? <span className="nav-link__label">{item.label}</span> : item.label}
        </NavLink>
      ))}
    </>
  );
}
